import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Credits, Projects } from '@usimweb/core/models';

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnInit, OnChanges {
  @Input() projects!: Projects[];

  @Input() credits!: number;

  public title = 'project (> 1%)';

  public projectGraph: any = {
    data: [{ type: 'pie' }],
    layout: {
      height: 400,
      width: 500,
    },
  };

  public typGraph: any = {
    data: [{ type: 'pie' }],
    layout: {
      height: 400,
      width: 500,
    },
  };

  constructor() {}

  ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.projects.length > 0 && changes['projects']) {
      this.setProjectPieChart();
      this.setTypPieChart();
    }
  }

  private setTypPieChart() {
    let sim: number = 0;
    let support: number = 0;

    this.projects.forEach((project: Projects) => {
      const credits = project.credits as Credits;

      sim += credits.simulation;
      support += credits.support;
    });

    const dict = {
      values: [sim, support],
      labels: ['Simulation', 'Support'],
      type: 'pie',
    };
    this.typGraph['data'][0] = dict;
  }

  public setProjectPieChart() {
    this.title = 'project  (> 1%)';

    let values: number[] = [];
    let labels: string[] = [];

    const total_credits = this.credits;

    this.projects.forEach((project: Projects) => {
      const credits = project.credits as Credits;

      const project_credits = credits.simulation + credits.support;
      const prop = (project_credits / total_credits) * 100;

      if (prop >= 0.5) {
        values.push(project_credits);
        labels.push(project.name);
      }
    });

    const dict = { values: values, labels: labels, type: 'pie' };

    this.projectGraph['data'][0] = dict;
  }

  public setVersionPieChart(uuid: string) {
    this.title = 'simulations';

    let values: number[] = [];
    let labels: string[] = [];

    const project = this.projects.filter((x) => x.uuid === uuid)[0];

    if (project.versions) {
      project.versions.forEach((version: any) => {
        const credits = (version.credits || 0) as number;
        values.push(credits);
        labels.push(version.title);
      });

      if (values.length === 0) {
        values.push(100);
        labels.push('no simulations');
      }

      const dict = { values: values, labels: labels, type: 'pie' };
      this.projectGraph['data'][0] = dict;
    }
  }
}
